import { Component, OnInit, inject } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UpperCasePipe } from '@angular/common';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { LoggerService } from '@app/shared/services/logger.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';
import { User } from '@app/shared/models/user.model';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { UserRepository } from '@app/shared/state/user/user.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-rich-club',
  imports: [
    ButtonComponent,
    UpperCasePipe,
    TranslateModule,
    SharedModule,
    AnimatedTimerComponent,
    NavigationButtonComponent,
  ],
  templateUrl: './rich-club.component.html',
  styleUrl: './rich-club.component.scss',
  standalone: true,
})
export class RichClubModalComponent implements OnInit {
  private eventManager = inject(EventManager);
  private translateService = inject(TranslateService);
  loggerService = inject(LoggerService);
  private userRepo = inject(UserRepository);
  richClubData = inject<Modal>(MAT_DIALOG_DATA);

  componentDestroy: () => Observable<unknown>;
  lang: string;
  loginCode: Array<string>;

  get user(): User {
    return this.userRepo.getUser();
  }

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;

    if (this.richClubData.data.code) {
      this.loginCode = this.richClubData.data.code.toString().split('');
    }
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.RichClubModalComponent, ModalType.View));
  }
}
